export const faqs = [
  {
    id: 1,
    question: 'How fast can we start?',
    answer: 'Discovery can begin within 3–5 business days. We prioritize quick turnaround while ensuring thorough planning.'
  },
  {
    id: 2,
    question: 'Do you handle hosting and SSL?',
    answer: 'Yes—setup, SSL, backups, and monitoring are available. We provide complete infrastructure management.'
  },
  {
    id: 3,
    question: 'Do you build POS and inventory systems?',
    answer: 'Yes—barcode-ready, multi-location, printable receipts. Our systems handle complex retail operations.'
  },
  {
    id: 4,
    question: 'Can you integrate AI chatbots?',
    answer: 'Yes—we add site chatbots for lead capture and support. Custom AI solutions for your specific needs.'
  },
  {
    id: 5,
    question: 'What technologies do you use?',
    answer: 'We use modern web technologies including React, Node.js, Python, and cloud platforms like AWS and Azure.'
  },
  {
    id: 6,
    question: 'Do you provide ongoing support?',
    answer: 'Yes, we offer maintenance packages including updates, monitoring, and technical support.'
  }
];


